import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '../../node_modules/@angular/common';

@Pipe({
  name: 'dateTimeFormat'
})
export class DateTimeFormatPipe extends DatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let fechaformateada;

    if(value){
      fechaformateada=value.replace(" ","T");
    }else{
      fechaformateada=value;
    }
    
    return super.transform(fechaformateada, 'dd/MM/yyyy HH:mm:ss');
  }

}



// WEBPACK FOOTER //
// ./src/app/date-time-format.pipe.ts